import { routeBy } from '../components/flows/FlowNavigation';
import { getPaymentRoute } from '../util/ConditionalNextScreenSelectors';
import { FlowConfig, PapScreenName, ScreenType, SharedScreenName } from './FlowTypes';
import { PATIENT_ASSISTANCE_SCREENS } from './nerva/PapConfig';

type PaymentScreenName = SharedScreenName | PapScreenName;

/**
 * Config for the /pay flow.
 */
export const PAY_CONFIG: FlowConfig<PaymentScreenName> = {
  name: 'PayConfig',
  showProgressBar: false,
  // We fire an `o-flow-entered` event manually from the `Pay` page (see `trackFlowEnteredAnalytics`) instead of
  // here because it needs to include traits derived from experiments being run.
  startEvent: undefined,
  screens: [
    {
      screenName: SharedScreenName.Payment,
      type: ScreenType.Payment,
      showHeaderBar: false,
      ...routeBy(getPaymentRoute, {
        newUser: SharedScreenName.FinishAccount,
        existingUser: SharedScreenName.DownloadApp,
        fallback: SharedScreenName.DownloadApp,
      }),
    },
    {
      screenName: SharedScreenName.FinishAccount,
      type: ScreenType.FinishAccount,
      layout: {
        // Cannot call `translate()` from config without calling `Localization.initialize()` in the same file.
        // Title and info coming from translation JSON to avoid 'missing translation' bug.
        subtitle: 'Fill in these last few details and you’re ready to go!',
        primaryButtonTitle: 'Continue',
      },
      nextScreen: SharedScreenName.DownloadApp,
    },
    {
      screenName: SharedScreenName.DownloadApp,
      type: ScreenType.DownloadApp,
      layout: {
        title: ['You’re all set!', 'Access your program now'],
        // Cannot call `translate()` from config without calling `Localization.initialize()` in the same file.
        // body coming from translation JSON to avoid 'missing translation' bug.
        alreadyPaid: false,
      },
    },
    ...PATIENT_ASSISTANCE_SCREENS,
  ],
};
